import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErroRoutingModule } from './erro-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ErroRoutingModule
  ]
})
export class ErroModule { }
